import {
  Box,
  SvgIcon,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";
import lock from '../../../assets/Images/lock.png';
import SectionTypeIcon from "../Icons/SectionTypeIcon";
import { COURSE_SECTION_TYPE_ID, ACTION_LABEL, renderTruncatedText } from "../../../core/Constant";

const AdminVideoListView = ({
  icon,
  onclick,
  size,
  loked = 0,
  heading,
  content,
  link,
  onPreviewClick,
  contentType = 0,
  item,
  index,
  fileName
}) => {
  const [progress, setProgress] = useState(false);
  const [locked, setLock] = useState(true)

  useEffect(() => {
    if (contentType !== 1 || contentType !== 2) {
      setProgress(true);
    }
  }, []);

  useEffect(() => {
    setLock(item?.is_locked);
  }, [item])


  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        flex: 1,
        width: 1,
        margin: 1,
        justifyContent: "flex-start",
        alignItems: "center",
        alignSelf: "center",
      }}
    >
      <Box sx={{ marginLeft: "1%", width: 100, maxWidth: "100px", marginRight: "2%" }}>
        {contentType !== 2 && index == 0 ? <Typography
          sx={{ fontSize: "16px", color: "#4a6375", fontWeight: 500, }}
        >
          Day {heading}
        </Typography> : null}

      </Box>
      <Box sx={{ /*flex: 0.05, mt:2*/ display: 'flex', flexDirection: 'column', justifyContent: 'center', mt: 1.5 }}>
        {Object.values(COURSE_SECTION_TYPE_ID).includes(contentType) ? (
          <SectionTypeIcon contentType={contentType} fileName={fileName ?? content}
            sx={{ marginRight: 5, width: "35px", height: "35px" }} />
        ) : (
          <SvgIcon sx={{ marginRight: 5, width: "30px", height: "30px" }}>
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 100 100"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="100%" height="100%" rx="50" fill="#28B882" />
              <path
                d="M80.4343 34.0572L36.9561 77.5354L17.0286 57.6079L22.1373 52.4992L36.9561 67.2818L75.3256 28.9485L80.4343 34.0572Z"
                fill="white"
              />
            </svg>
          </SvgIcon>
        )}
      </Box>
      <Box
        sx={{
          width: 400,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start",
          maxWidth: "600px",
        }}
      >
        <Box
          sx={{
            alignItems: "left",
            justifyContent: "center",
            display: "flex",
            padding: 2,
          }}
        >
          <SvgIcon sx={{ width: 7, height: 7 }}>
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 100 100"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="50" cy="50" r="50" fill="#4A6375" />
            </svg>
          </SvgIcon>
        </Box>
        <Typography
          sx={{ fontSize: "16px", color: "#4a6375", fontWeight: 500 }}
        >
          {renderTruncatedText(content, { limit: 40 })}
        </Typography>
      </Box>
      {((!locked) || loked) ?
        <Box sx={{ width: 150, display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
          <Typography
            sx={{ fontSize: "16px", color: "rgb(152, 52, 240)", fontWeight: 500 }}
          >
            {ACTION_LABEL[contentType] || "Completed"}
          </Typography>
        </Box>
        :
        <Box sx={{ width: 150, display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
          <img style={{ marginLeft: 2, width: "25px", height: "25px" }} src={lock} />
        </Box>
      }
    </Box>
  );
};

export default AdminVideoListView;


const LockedIcon = () => {
  return (
    <SvgIcon sx={{ marginLeft: 2, width: "25px", height: "25px" }}>
      <svg
        width="100"
        height="103"
        viewBox="0 0 100 103"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_101_3710)">
          <path
            fill-rule="evenodd"
            clipRule="evenodd"
            d="M68.6802 44.3264H31.4258V31.8511C31.4258 26.6004 33.5152 21.8235 36.8949 18.3691C40.2748 14.9047 44.9256 12.7532 50.0482 12.7532C55.1709 12.7532 59.8312 14.9049 63.2013 18.3691C66.581 21.8235 68.6802 26.6006 68.6802 31.8511V44.3264ZM84.5584 46.9518C83.5761 45.955 82.3726 45.1851 81.0246 44.7509V31.8511C81.0246 23.1164 77.5388 15.1712 71.9252 9.41719C66.3115 3.66317 58.5697 0.100098 50.0482 0.100098C41.5265 0.100098 33.7847 3.66317 28.1711 9.41719C22.5574 15.1712 19.0717 23.1164 19.0717 31.8511V44.7114C17.6851 45.1456 16.4429 45.9252 15.4416 46.9518C13.8625 48.5804 12.8802 50.811 12.8802 53.2782V93.448C12.8802 95.9154 13.8625 98.1459 15.4416 99.7743C17.0302 101.393 19.2066 102.4 21.6136 102.4H78.3863C80.7935 102.4 82.9697 101.393 84.5584 99.7743C86.1375 98.1459 87.1197 95.9154 87.1197 93.448V53.2782C87.1199 50.8108 86.1377 48.5804 84.5584 46.9518ZM43.9529 63.6415C45.5031 62.0623 47.6408 61.0754 50 61.0754C52.3591 61.0754 54.4966 62.0623 56.047 63.6415C57.5974 65.2306 58.5506 67.4218 58.5506 69.8397C58.5506 71.7248 57.9728 73.4619 56.9906 74.8931C56.172 76.0776 55.0744 77.0448 53.7937 77.6962V81.7626C53.7937 82.8284 53.3701 83.8056 52.6767 84.5062C51.9929 85.2069 51.0494 85.6512 49.9998 85.6512C48.9597 85.6512 48.0066 85.2069 47.3228 84.5062C46.6392 83.8056 46.2058 82.8284 46.2058 81.7626V77.6962C44.9347 77.0448 43.8371 76.0776 43.0185 74.8931C42.0267 73.4621 41.449 71.725 41.449 69.8397C41.4494 67.4216 42.4123 65.2304 43.9529 63.6415Z"
            fill="#2D3945"
            fill-opacity="0.4"
          />
        </g>
        <defs>
          <clipPath id="clip0_101_3710">
            <rect width="100" height="102.5" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}